import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import "./assets/css/brands.css"
import "./assets/css/style.css"
import "./assets/css/payments-style.css"
import "./assets/css/matching-tpay.css"
import i18n from "@/i18n";
import { createGtag } from "vue-gtag";

axios.defaults.baseURL = window.API_URL;
axios.defaults.headers.common = {
  'Content-Type': 'application/json;charset=UTF-8',
}

const app = createApp(App);

const gtagId = process.env.VUE_APP_GTAG;

if (gtagId) {
  const gtag = createGtag({
    tagId: gtagId,
  })

  app.use(gtag)
}

app.use(i18n).use(VueAxios, axios).use(router).mount('#app')
